import jsonApi, { multipartInstance } from '../../utils/jsonApi'
import { roles } from '../../utils/constants'

import http from '../../utils/http'

const chatModel = 'room'

export const fetchRoomById = id => {
  return jsonApi
    .find(chatModel, id, {
      params: {
        include: 'room_participants.user'
      }
    })
    .then(res => res)
}
export const createRoomWithFormData = data => {
  return multipartInstance
    .post('rooms', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(res => res)
}

export const fetchRooms = ({ page, params }) => {
  return jsonApi
    .findAll(chatModel, {
      params: {
        ...params,
        'page[number]': page || 1,
        include: 'room_participants.user'
      }
    })
    .then(res => res)
}

export const deleteRoom = data => {
  return http.delete(`rooms/${data}`)
}

export const createRoom = data => {
  return http
    .post('rooms', {
      data: {
        type: 'rooms',
        attributes: {
          ...data
        }
      }
    })
    .then(res => {
      return res
    })
}

export const createMessageWithFile = data => {
  return multipartInstance
    .post('/new_messages', data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(res => {
      return res.data
    })
}

export const createMessage = async data => {
  return http
    .post('new_messages', {
      data: {
        type: 'new_messages',
        attributes: {
          ...data
        }
      }
    })
    .then(res => {
      return res
    })
}

export const editMessage = async data => {
  return http
    .put(`/new_messages/${data.id}`, {
      data: {
        type: 'new_messages',
        id: data.id,
        attributes: {
          ...data.data
        }
      }
    })
    .then(res => {
      const returnData = { id: res.data.data.id, ...res.data.data.attributes }
      return returnData
    })
}

export const getInterventionMessages = async data => {
  return jsonApi
    .findAll('new_messages', {
      params: {
        'q[parent_room_id_eq]': data.roomId,
        'q[message_type_eq]': 0
      }
    })
    .then(res => {
      return res
    })
}

export const getMessagesJsonApi = async data => {
  return jsonApi
    .findAll('new_messages', {
      params: {
        'q[room_id_eq]': data.roomId,
        'q[s]': 'created_at desc',
        ...data.params,
        include: 'user,parent'
      }
    })
    .then(res => {
      return res
    })
}

export const getMessages = async data => {
  const isAdmin = data.currentOccupation.includes(roles.SCHOOL_ADMIN)
  const endpoint = 'new_messages'
  return http
    .get(endpoint, {
      params: {
        'q[s]': 'created_at desc',
        ...(isAdmin
          ? { 'q[room_room_participants_user_fractal_id_eq]': data.fractalId }
          : {}),
        ...data.params,
        include: 'user,parent,room.room_participants.user'
      }
    })
    .then(res => {
      return res.data
    })
}

export const exportMessages = async data => {
  return http
    .get('new_messages/messages_by_period', {
      params: data
    })
    .then(res => res)
}
